import React from 'react';
import { ParticleHero } from '../components/ParticleHero';
import { About } from '../components/About';
import { Writing } from '../components/Writing';
import { Speaking } from '../components/Speaking';
import { Work } from '../components/Work';
import { Contact } from '../components/Contact';
import { Section } from '../components/ui/Section';
import { ChevronDown } from 'lucide-react';
import { Theme } from '../hooks/useTheme';
interface HomeProps {
  theme: Theme;
  onNavigateToSpeaking: (slug: string) => void;
  onNavigateToWriting: (slug: string) => void;
}
export function Home({
  theme,
  onNavigateToSpeaking,
  onNavigateToWriting
}: HomeProps) {
  return <main className="bg-background text-foreground min-h-screen" data-id="element-161">
      {/* Hero Section */}
      <div className="relative h-screen w-full flex flex-col justify-center items-center overflow-hidden" data-id="element-162">
        <ParticleHero theme={theme} data-id="element-163" />

        <div className="z-10 text-center space-y-6 px-4 animate-in fade-in zoom-in duration-1000" data-id="element-164">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter bg-clip-text text-transparent bg-gradient-to-b from-foreground to-foreground/60" data-id="element-165">
            Macs Dickinson
          </h1>
          <p className="text-xl md:text-2xl text-muted-foreground font-light tracking-wide max-w-2xl mx-auto" data-id="element-166">
            Engineering Director @ LHV Bank
          </p>
          <div className="h-px w-24 bg-gradient-to-r from-transparent via-border to-transparent mx-auto my-8" data-id="element-167" />
          <p className="text-sm md:text-base text-muted-foreground/80 font-mono tracking-wider italic" data-id="element-168">
            Talking about software and other less interesting things since 2009
          </p>
        </div>

        <div className="absolute bottom-12 left-1/2 transform -translate-x-1/2 animate-bounce text-muted-foreground" data-id="element-169">
          <ChevronDown size={24} data-id="element-170" />
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-6 md:px-12 space-y-32 pb-24" data-id="element-171">
        <About data-id="element-172" />
        <Speaking onNavigate={onNavigateToSpeaking} data-id="element-173" />
        <Contact data-id="element-174" />
      </div>
    </main>;
}